import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { collapseClasses } from './collapseClasses';
import { ButtonTitleRoot } from './Collapse.style';

const ButtonTitle = ({
  isOpen,
  children,
  onClick,
  disabled,
  buttonVariant,
  IconProps: ExpandIconProps,
  ...rest
}) => {
  const btnRef = useRef(null);
  const iconPosition = buttonVariant === 'text' ? 'startIcon' : 'endIcon';
  const ExpandIcon = isOpen ? ExpandLess : ExpandMore;
  const ExpandIconElement = (
    <ExpandIcon className={collapseClasses.expandIcon} {...ExpandIconProps} />
  );

  return (
    <ButtonTitleRoot
      ref={btnRef}
      size={buttonVariant === 'text' ? 'small' : 'large'}
      variant="text"
      disabled={disabled}
      onClick={onClick}
      // we blur onMouseUp so we won't have a focus state
      // if onMouseUp is passed via ...rest, its the consumer's responsibility to do it.
      onMouseUp={() => btnRef.current.blur()}
      data-qa-id="collapse--button"
      fullWidth={buttonVariant !== 'text'}
      {...{ [iconPosition]: ExpandIconElement }}
      buttonVariant={buttonVariant}
      {...rest}>
      {children}
    </ButtonTitleRoot>
  );
};

ButtonTitle.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  buttonVariant: PropTypes.oneOf(['outlined', 'text']),
  IconProps: PropTypes.shape({
    'aria-label': PropTypes.string.isRequired
  })
};

export default ButtonTitle;
